import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import {Button, FormControl, Icon, Typography} from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from "prop-types";


class UecareUploadButton extends Component {


    static propTypes = {
        className: PropTypes.any,
        classes: PropTypes.any,
        color: PropTypes.string,
        icon: PropTypes.string,
        id: PropTypes.number,
        label: PropTypes.string,
        name: PropTypes.any,
        onClick: PropTypes.func,
        value: PropTypes.any,
        variant: PropTypes.string
    };


    constructor(props) {
        super(props);
        this.handleFileSelect = this.handleFileSelect.bind(this); // 讓 handleFileSelect 中的 this.refs 不會 undefined
    }

    handleFileSelect(e) {
        e.preventDefault();
        this.refs.fileUploader.click();
    }

    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function (error) {
                reject(error);
            };
        });
    };

    getFileSize = (file) => {
        return file.size;
    };

    handleFileChange = async (controller) => {
        try {
            const uploadFile = this.refs.fileUploader.files[0];
            if (this.getFileSize(uploadFile) / 1024 / 1024 > 16) throw new Error('上傳檔案不能超過 16 MB'); // 比 16 MB 大
            const base64File = await this.getBase64(uploadFile);
            if (this.props.onClick) await this.props.onClick(base64File);
        } catch (e) {
            console.error(e);
            return null;
        }
    };

    render() {
        const {classes} = this.props;

        return (
            <div className="flex">
                <input type="file" id="fileUploader" ref="fileUploader"
                       onChange={this.handleFileChange} style={{display: "none"}}/>
                <div className="min-w-48 pt-20">
                    <Icon color="action">{this.props.icon}</Icon>
                </div>
                <FormControl fullWidth>
                    <Button id={this.props.id}
                            name={this.props.name}
                            className={classNames(classes.button, this.props.className)}
                            variant={this.props.variant}
                            color={this.props.color}
                            value={this.props.value}
                            onClick={this.handleFileSelect}>
                        {this.props.label}
                    </Button>
                    <Typography className="text-11 capitalize" color="textSecondary">
                        只接受 16 MB 以下的檔案
                    </Typography>
                </FormControl>
            </div>
        );
    }
}


const styles = theme => ({
    button: {
        marginTop: theme.spacing.unit * 2,
    },
});

export default withStyles(styles, {withTheme: true})(UecareUploadButton);



// WEBPACK FOOTER //
// ./src/components/UecareUploadButton.js